<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :options="[
        { type: 'date', label: '점검일' },
        { type: 'text', label: '점검장소' },
        { type: 'disaster', label: '재해형태' },
        { type: 'file', label: '필수 첨부서류', value: 'file', labelStyle: 'color:#EA5455' },
      ]"
      :board="this.board"
      :is-print="isPrint"
    />

    <!--    위험작업 목록-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 작업구분</h5>
      </vs-col>
    </vs-row>

    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-3 flex items-center" v-for="checkbox in form.inspectionList" v-bind:key="checkbox.id">
        <div v-if="isPrint || board.readonly" class="flex">
          <div v-if="checkbox.check" style="background: #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          <div v-else style="border: 1px solid #200c63" class="w-5 h-5 rounded-sm text-white flex justify-center items-center mr-2">
            <vs-icon icon="check" size="x-small"></vs-icon>
          </div>
          {{ checkbox.label }}
        </div>
        <label v-else class="flex">
          <vs-checkbox :readonly="board.readonly" v-model="checkbox.check" @change="checkForm"> </vs-checkbox>
          {{ checkbox.label }}
        </label>
      </div>
    </div>

    <!--    장비 정보-->
    <vs-row class="mt-6">
      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
        <h5><i class="dot" /> 장비 정보</h5>
      </vs-col>
    </vs-row>
    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">장비 업체명</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_1 }}</p>
        <ml-input v-else :readonly="board.readonly" v-model="form.inputB_1" class="w-full flex-1" />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">장비 운전원</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_2 }}</p>
        <ml-input v-else :readonly="board.readonly" v-model="form.inputB_2" class="w-full flex-1" />
      </div>
      <!--      <div class="col-span-4 flex items-center">-->
      <!--        <div class="label-text mr-4">운전원 면허번호</div>-->
      <!--        <p v-if="isPrint" class="print-input">{{ form.inputB_3 }}</p>-->
      <!--        <ml-input-->
      <!--          v-else-->
      <!--          :readonly="board.readonly"-->
      <!--          v-model="form.inputB_3"-->
      <!--          class="w-full flex-1"-->
      <!--        />-->
      <!--      </div>-->

      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">장비 종류(기종 및 모델명)</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_4 }}</p>
        <ml-input v-else :readonly="board.readonly" v-model="form.inputB_4" class="w-full flex-1" />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">장비 형식 및 규격(정격하종)</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_5 }}</p>
        <ml-input v-else :readonly="board.readonly" v-model="form.inputB_5" class="w-full flex-1" />
      </div>
      <!--      <div class="col-span-4 flex items-center">-->
      <!--        <div class="label-text mr-4">장비 지지방법 및 기타</div>-->
      <!--        <p v-if="isPrint" class="print-input">{{ form.inputB_6 }}</p>-->
      <!--        <ml-input-->
      <!--          v-else-->
      <!--          :readonly="board.readonly"-->
      <!--          v-model="form.inputB_6"-->
      <!--          class="w-full flex-1"-->
      <!--        />-->
      <!--      </div>-->
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작업지휘자</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_7 }}</p>
        <ml-input v-else :readonly="board.readonly" v-model="form.inputB_7" class="w-full flex-1" />
      </div>
      <div class="col-span-4 flex items-center">
        <div class="label-text mr-4">작업유도자</div>
        <p v-if="isPrint" class="print-input">{{ form.inputB_8 }}</p>
        <ml-input v-else :readonly="board.readonly" v-model="form.inputB_8" class="w-full flex-1" />
      </div>
    </div>

    <!--    현장개요-->
    <!--    <vs-row class="mt-6">-->
    <!--      <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">-->
    <!--        <h5>-->
    <!--          <i class="dot" /> 현장개요-->
    <!--        </h5>-->
    <!--      </vs-col>-->
    <!--    </vs-row>-->
    <!--    <div class="grid grid-cols-12 gap-x-6 gap-y-4 mt-4">-->
    <!--      <div class="col-span-4 flex items-center">-->
    <!--        <div class="label-text mr-4">현장주소</div>-->
    <!--        <p v-if="isPrint" class="print-input">{{ form.inputC_1 }}</p>-->
    <!--        <company-selector-->
    <!--          v-else-->
    <!--          :readonly="board.readonly"-->
    <!--          v-model="form.inputC_1"-->
    <!--          class="w-full flex-1"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-center">-->
    <!--        <div class="label-text mr-4">공사금액</div>-->
    <!--        <p v-if="isPrint" class="print-input">{{ form.inputC_2 }}</p>-->
    <!--        <ml-input-->
    <!--          v-else-->
    <!--          :readonly="board.readonly"-->
    <!--          class="w-full flex-1"-->
    <!--          placeholder=""-->
    <!--          v-model="form.inputC_2"/>-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-center">-->
    <!--        <div class="label-text mr-4">공사기간</div>-->
    <!--        <p v-if="isPrint" class="print-input">-->
    <!--          {{ form.inputC_3 }} ~ {{ form.inputC_4 }}-->
    <!--        </p>-->
    <!--        <div v-else class="flex-1 flex items-center">-->
    <!--          <date-selector-->
    <!--            class="w-full flex-1"-->
    <!--            v-model="form.inputC_3"-->
    <!--            :readonly="board.readonly"-->
    <!--          />-->
    <!--          <p class="px-2">~</p>-->
    <!--          <date-selector-->
    <!--            class="w-full flex-1"-->
    <!--            v-model="form.inputC_4"-->
    <!--            :readonly="board.readonly"-->
    <!--          />-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="col-span-4 flex items-center">-->
    <!--        <div class="label-text mr-4">공종명</div>-->
    <!--        <p v-if="isPrint" class="print-input">{{ form.inputC_5 }}</p>-->
    <!--        <ml-input-->
    <!--          v-else-->
    <!--          :readonly="board.readonly"-->
    <!--          v-model="form.inputC_5"-->
    <!--          class="w-full flex-1"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-center">-->
    <!--        <div class="label-text mr-4">작업장소</div>-->
    <!--        <p v-if="isPrint" class="print-input">{{ form.inputC_6 }}</p>-->
    <!--        <ml-input-->
    <!--          v-else-->
    <!--          :readonly="board.readonly"-->
    <!--          v-model="form.inputC_6"-->
    <!--          class="w-full flex-1"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-center">-->
    <!--        <div class="label-text mr-4">작업기간</div>-->
    <!--        <p v-if="isPrint" class="print-input">-->
    <!--          {{ form.inputC_7 }} ~ {{ form.inputC_8 }}-->
    <!--        </p>-->
    <!--        <div v-else class="flex-1 flex items-center">-->
    <!--          <date-selector-->
    <!--            class="w-full flex-1"-->
    <!--            v-model="form.inputC_7"-->
    <!--            :readonly="board.readonly"-->
    <!--          />-->
    <!--          <p class="px-2">~</p>-->
    <!--          <date-selector-->
    <!--            class="w-full flex-1"-->
    <!--            v-model="form.inputC_8"-->
    <!--            :readonly="board.readonly"-->
    <!--          />-->
    <!--        </div>-->
    <!--      </div>-->

    <!--      <div class="col-span-4 flex items-start mt-4">-->
    <!--        <div class="label-text mr-4 mt-2">-->
    <!--          상세 작업내용-->
    <!--        </div>-->
    <!--        <p v-if="isPrint" class="print-textarea">{{ form.inputC_9 }}</p>-->
    <!--        <ml-textarea-->
    <!--          :readonly="board.readonly"-->
    <!--          v-else-->
    <!--          v-model="form.inputC_9"-->
    <!--          class="flex-1 w-full"-->
    <!--          rows="5"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-start mt-4">-->
    <!--        <div class="label-text mr-4 mt-2">-->
    <!--          작업순서-->
    <!--        </div>-->
    <!--        <p v-if="isPrint" class="print-textarea">{{ form.inputC_10 }}</p>-->
    <!--        <ml-textarea-->
    <!--          :readonly="board.readonly"-->
    <!--          v-else-->
    <!--          v-model="form.inputC_10"-->
    <!--          class="flex-1 w-full"-->
    <!--          rows="5"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-start mt-4">-->
    <!--        <div class="label-text mr-4 mt-2">-->
    <!--          지장물 현황-->
    <!--        </div>-->
    <!--        <p v-if="isPrint" class="print-textarea">{{ form.inputC_11 }}</p>-->
    <!--        <ml-textarea-->
    <!--          :readonly="board.readonly"-->
    <!--          v-else-->
    <!--          v-model="form.inputC_11"-->
    <!--          class="flex-1 w-full"-->
    <!--          rows="5"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-start mt-4">-->
    <!--        <div class="label-text mr-4 mt-2">-->
    <!--          인원투입계획-->
    <!--        </div>-->
    <!--        <p v-if="isPrint" class="print-textarea">{{ form.inputC_12 }}</p>-->
    <!--        <ml-textarea-->
    <!--          :readonly="board.readonly"-->
    <!--          v-else-->
    <!--          v-model="form.inputC_12"-->
    <!--          class="flex-1 w-full"-->
    <!--          rows="5"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-start mt-4">-->
    <!--        <div class="label-text mr-4 mt-2">-->
    <!--          자재투입계획-->
    <!--        </div>-->
    <!--        <p v-if="isPrint" class="print-textarea">{{ form.inputC_13 }}</p>-->
    <!--        <ml-textarea-->
    <!--          :readonly="board.readonly"-->
    <!--          v-else-->
    <!--          v-model="form.inputC_13"-->
    <!--          class="flex-1 w-full"-->
    <!--          rows="5"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-start mt-4">-->
    <!--        <div class="label-text mr-4 mt-2">-->
    <!--          장비투입계획-->
    <!--        </div>-->
    <!--        <p v-if="isPrint" class="print-textarea">{{ form.inputC_14 }}</p>-->
    <!--        <ml-textarea-->
    <!--          :readonly="board.readonly"-->
    <!--          v-else-->
    <!--          v-model="form.inputC_14"-->
    <!--          class="flex-1 w-full"-->
    <!--          rows="5"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-start mt-4">-->
    <!--        <div class="label-text mr-4 mt-2">-->
    <!--          유해·위험요인 및 재해형태-->
    <!--        </div>-->
    <!--        <p v-if="isPrint" class="print-textarea">{{ form.inputC_15 }}</p>-->
    <!--        <ml-textarea-->
    <!--          :readonly="board.readonly"-->
    <!--          v-else-->
    <!--          v-model="form.inputC_15"-->
    <!--          class="flex-1 w-full"-->
    <!--          rows="5"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-start mt-4">-->
    <!--        <div class="label-text mr-4 mt-2">-->
    <!--          안전대책-->
    <!--        </div>-->
    <!--        <p v-if="isPrint" class="print-textarea">{{ form.inputC_16 }}</p>-->
    <!--        <ml-textarea-->
    <!--          :readonly="board.readonly"-->
    <!--          v-else-->
    <!--          v-model="form.inputC_16"-->
    <!--          class="flex-1 w-full"-->
    <!--          rows="5"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-start mt-4">-->
    <!--        <div class="label-text mr-4 mt-2">-->
    <!--          사고 시 비상 대응체계-->
    <!--        </div>-->
    <!--        <p v-if="isPrint" class="print-textarea">{{ form.inputC_17 }}</p>-->
    <!--        <ml-textarea-->
    <!--          :readonly="board.readonly"-->
    <!--          v-else-->
    <!--          v-model="form.inputC_17"-->
    <!--          class="flex-1 w-full"-->
    <!--          rows="5"-->
    <!--        />-->
    <!--      </div>-->
    <!--      <div class="col-span-4 flex items-center">-->
    <!--        <div class="label-text mr-4">작업 계획도 및 관련 도면 첨부</div>-->
    <!--        <p v-if="isPrint" class="print-input">-->
    <!--          {{ form.inputC_18.fileName }}-->
    <!--        </p>-->
    <!--        <file-uploader-->
    <!--          :readonly="board.readonly"-->
    <!--          v-else-->
    <!--          v-model="form.inputC_18"-->
    <!--          class="w-full flex-1"-->
    <!--        />-->
    <!--      </div>-->
    <!--    </div>-->

    <!--    목록표 -->
    <table-inspect-division
      class="mt-2"
      v-for="(inspection, indexRows) in form.inspectionList"
      v-bind:key="inspection.id"
      :is-print="isPrint"
      :is-readonly="board.readonly"
      :is-show-title="true"
      :title="inspection.title"
      :list="inspection.list"
      v-if="inspection.check"
      @update-list-check="
        (param1, param2, param3) => {
          updateListCheck(indexRows, param1, param2, param3);
        }
      "
    />

    <!-- 확인자 -->
    <div>
      <div class="mt-4">
        <h5><i class="dot"></i> 확인자</h5>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>안전관리자</div>
          <ml-input v-if="!isPrint" v-model="form.sign1.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign1.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign1.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign1.sign" :src="form.sign1.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
      <div class="writeGridContainer" style="align-items: center">
        <div>
          <div>관리책임자</div>
          <ml-input v-if="!isPrint" v-model="form.sign2.name" :readonly="board.readonly" />
          <span v-else class="print-input">{{ form.sign2.name }}</span>
        </div>
        <div style="align-items: center">
          <div class="pt-2">서명</div>
          <sign-field v-if="!isPrint && !board.readonly" v-model="form.sign2.sign" class="w-full flex-1 p-1" />
          <div v-else class="w-full flex-1 p-1">
            <img v-if="form.sign2.sign" :src="form.sign2.sign" width="100%" alt="Signature" class="signatureImg" />
            <div v-else class="signatureImg"></div>
          </div>
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly" title="작업 계획도 및 관련 도면 첨부"></file-upload-module>
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import PopupPlanProject from "@/views/project/popup/PopupPlanProject";
import DateSelector from "@/components/selector/DateSelector";
import PopupProjectSetting from "@/views/project/PopupProjectSetting";
import MemberSelector from "@/components/selector/MemberSelector";
import CompanySelector from "@/components/selector/CompanySelector";
import FileUploader from "@/components/FileUploader";
import FileUploadModule from "@/views/modules/FileUploadModule";
import TableInspect from "@/components/TableInspect";
import TableInspectDivision from "@/components/TableInspectDivision";
import SignField from "@/components/SignField.vue";
import { required } from "vuelidate/lib/validators";

export default {
  components: {
    SignField,
    TableInspectDivision,
    TableInspect,
    FieldSelectModule,
    FileUploadModule,
    FileUploader,
    CompanySelector,
    MemberSelector,
    PopupProjectSetting,
    DateSelector,
    PopupPlanProject,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  validations: {
    form: {
      stdInfo: {
        file: { required },
      },
    },
  },
  watch: {
    value: {
      important: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.inspectionList || this.form.inspectionList.length === 0) {
          this.form.inspectionList = this.inspectionList;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    checkForm() {
      this.form.typeTitleList = [];
      for (const data of this.form.inspectionList) {
        if (data.check) {
          this.form.typeTitleList.push(data.label);
        }
      }
    },
    updateListCheck(indexList, indexTableRows, indexRows, text) {
      this.form.inspectionList[indexList].list[indexTableRows].list[indexRows].is_checked = text;
    },

    validate() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        if (!this.$v.form.stdInfo.file.required) return "필수 첨부서류를 첨부해주세요.";
      }
    },
  },
  computed: {
    getInspectionListTitle() {
      let result = "";
      for (const data of this.form.inspectionList) {
        if (data.check) {
          result += `${data.label} , `;
        }
      }

      if (result.length > 0) {
        result = result.substring(0, result.length - 2);
      }
      return result;
    },
    inspectionList() {
      return [
        {
          id: 1,
          label: "화학설비와 그 부속설비 사용작업",
          check: false,
          title: "사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)",
          list: [
            {
              headerTitle: "작업계획서 내용",
              headerYesTitle: "작성",
              headerNoTitle: "미작성",
              isTypeMode: true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: "가",
                  label: "밸브·콕 등의 조작(해당 화학설비에 원재료를 공급하거나 해당 화학설비에서 제품 등을 꺼내는 경우만 해당한다) ",
                  is_checked: "",
                },
                {
                  id: 2,
                  type: "나",
                  label: "냉각장치·가열장치·교반장치(攪拌裝置) 및 압축장치의 조작",
                  is_checked: "",
                },
                {
                  id: 3,
                  type: "다",
                  label: "계측장치 및 제어장치의 감시 및 조정 ",
                  is_checked: "",
                },
                {
                  id: 4,
                  type: "라",
                  label: "안전밸브, 긴급차단장치, 그 밖의 방호장치 및 자동경보장치의 조정",
                  is_checked: "",
                },
                {
                  id: 5,
                  type: "마",
                  label: "덮개판·플랜지(flange)·밸브·콕 등의 접합부에서 위험물 등의 누출 여부에 대한 점검 ",
                  is_checked: "",
                },
                {
                  id: 6,
                  type: "바",
                  label: "시료의 채취 ",
                  is_checked: "",
                },
                {
                  id: 7,
                  type: "사",
                  label: "화학설비에서는 그 운전이 일시적 또는 부분적으로 중단된 경우의 작업방법 또는 운전 재개 시의 작업방법",
                  is_checked: "",
                },
                {
                  id: 8,
                  type: "아",
                  label: "이상 상태가 발생한 경우의 응급조치 ",
                  is_checked: "",
                },
                {
                  id: 9,
                  type: "자",
                  label: "위험물 누출 시의 조치 ",
                  is_checked: "",
                },
                {
                  id: 10,
                  type: "차",
                  label: "덮개판·플랜그 밖에 폭발·화재를 방지하기 위하여 필요한 조치지(flange)·밸브·콕 등의 접합부에서 위험물 등의 누출 여부에 대한 점검 ",
                  is_checked: "",
                },
              ],
            },
          ],
        },
        {
          id: 2,
          label: "전기작업",
          check: false,
          title: "사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)",
          list: [
            {
              headerTitle: "작업계획서 내용",
              headerYesTitle: "작성",
              headerNoTitle: "미작성",
              isTypeMode: true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: "가",
                  label: "전기작업의 목적 및 내용",
                  is_checked: "",
                },
                {
                  id: 2,
                  type: "나",
                  label: "전기작업 근로자의 자격 및 적정 인원",
                  is_checked: "",
                },
                {
                  id: 3,
                  type: "다",
                  label: "작업 범위, 작업책임자 임명, 전격·아크 섬광·아크 폭발 등 전기 위험 요인 파악, 접근 한계거리, 활선접근 경보장치 휴대 등 작업시작 전에 필요한 사항",
                  is_checked: "",
                },
                {
                  id: 4,
                  type: "라",
                  label: "제319조에 따른 전로 차단에 관한 작업계획 및 전원(電源) 재투입 절차 등 작업 상황에 필요한 안전 작업 요령",
                  is_checked: "",
                },
                {
                  id: 5,
                  type: "마",
                  label: "절연용 보호구 및 방호구, 활선작업용 기구·장치 등의 준비·점검·착용·사용 등에 관한 사항",
                  is_checked: "",
                },
                {
                  id: 6,
                  type: "바",
                  label: "점검·시운전을 위한 일시 운전, 작업 중단 등에 관한 사항",
                  is_checked: "",
                },
                {
                  id: 7,
                  type: "사",
                  label: "교대 근무 시 근무 인계(引繼)에 관한 사항",
                  is_checked: "",
                },
                {
                  id: 8,
                  type: "아",
                  label: "전기작업장소에 대한 관계 근로자가 아닌 사람의 출입금지에 관한 사항",
                  is_checked: "",
                },
                {
                  id: 9,
                  type: "자",
                  label: "전기안전작업계획서를 해당 근로자에게 교육할 수 있는 방법과 작성된 전기안전작업계획서의 평가·관리계획",
                  is_checked: "",
                },
                {
                  id: 10,
                  type: "차",
                  label: "전기 도면, 기기 세부 사항 등 작업과 관련되는 자료",
                  is_checked: "",
                },
              ],
            },
          ],
        },
        {
          id: 3,
          label: "궤도와 그 밖의 관련설비의 보수·점검 작업",
          check: false,
          title: "사전조사 및 작업계획서 내용(산업안전보건기준에 관한 규칙 [별표4], 제38조 제1항관련)",
          list: [
            {
              headerTitle: "작업계획서 내용",
              headerYesTitle: "작성",
              headerNoTitle: "미작성",
              isTypeMode: true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: "가",
                  label: "적절한 작업 인원 ",
                  is_checked: "",
                },
                {
                  id: 2,
                  type: "나",
                  label: "작업량",
                  is_checked: "",
                },
                {
                  id: 3,
                  type: "다",
                  label: "작업순서",
                  is_checked: "",
                },
                {
                  id: 4,
                  type: "라",
                  label: "작업방법 및 위험요인에 대한 안전조치방법 등",
                  is_checked: "",
                },
              ],
            },
          ],
        },
        {
          id: 4,
          label: "입환작업",
          check: false,
          title: "작업시작 전까지 확인사항 [별지 제3호의2서식] <신설 2018.09.28>",
          list: [
            {
              headerTitle: "작업시작 전까지 확인사항",
              headerYesTitle: "작성",
              headerNoTitle: "미작성",
              isTypeMode: true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: "가",
                  label: "철도운행안전협의 결과 작업원에게 통보",
                  is_checked: "",
                },
                {
                  id: 2,
                  type: "나",
                  label: "작업구간(지장선로, 키로정 등) 확인",
                  is_checked: "",
                },
                {
                  id: 3,
                  type: "다",
                  label: "전차선로 단전구간 확인",
                  is_checked: "",
                },
                {
                  id: 4,
                  type: "라",
                  label: "작업원 이동 경로 작업자에게 통보",
                  is_checked: "",
                },
                {
                  id: 5,
                  type: "마",
                  label: "열차감시원 배치계획 적정성 및 휴대품",
                  is_checked: "",
                },
                {
                  id: 6,
                  type: "바",
                  label: "열차접근 시 대피 장소 작업원에게 통보",
                  is_checked: "",
                },
                {
                  id: 7,
                  type: "사",
                  label: "운전취급자와 연락체계 확인",
                  is_checked: "",
                },
                {
                  id: 8,
                  type: "아",
                  label: "전기철도안전관리자 배치",
                  is_checked: "",
                },
                {
                  id: 9,
                  type: "자",
                  label: "건널목 임시관리원 배치",
                  is_checked: "",
                },
                {
                  id: 10,
                  type: "차",
                  label: "합동 또는 병행작업 시 타분야와 협의",
                  is_checked: "",
                },
              ],
            },
            {
              headerTitle: "「작업시행승인」된 상태에서 작업시작 전까지 확인사항",
              headerYesTitle: "작성",
              headerNoTitle: "미작성",
              isTypeMode: true,
              isInputMode: false,
              list: [
                {
                  id: 1,
                  type: "가",
                  label: "작업시행승인사항 작업원에게 통보",
                  is_checked: "",
                },
                {
                  id: 2,
                  type: "나",
                  label: "열차감시원 정위치 확인(무선통화)",
                  is_checked: "",
                },
                {
                  id: 3,
                  type: "다",
                  label: "열차감시원~작업현장간 경보체계 확인",
                  is_checked: "",
                },
                {
                  id: 4,
                  type: "라",
                  label: "공사감독자 또는 작업책임자 작업원 인솔",
                  is_checked: "",
                },
                {
                  id: 5,
                  type: "마",
                  label: "단락용 동선 설치(고속선 CPT 등을 체결)",
                  is_checked: "",
                },
                {
                  id: 6,
                  type: "바",
                  label: "작업 인접선 안전조치",
                  is_checked: "",
                },
                {
                  id: 7,
                  type: "사",
                  label: "작업 관련 표지류 설치",
                  is_checked: "",
                },
                {
                  id: 8,
                  type: "아",
                  label: "서행 관련 임시신호기 등의 설치",
                  is_checked: "",
                },
                {
                  id: 9,
                  type: "자",
                  label: "전차선로 단전 조치(접지걸이 포함)",
                  is_checked: "",
                },
                {
                  id: 10,
                  type: "차",
                  label: "건설기계 작업지휘자 또는 유도자 배치",
                  is_checked: "",
                },
              ],
            },
          ],
        },
      ];
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},
        inspectionList: [],
        typeTitleList: [],

        inputB_1: "",
        inputB_2: "",
        inputB_3: "",
        inputB_4: "",
        inputB_5: "",
        inputB_6: "",
        inputB_7: "",
        inputB_8: "",

        inputC_1: "",
        inputC_2: "",
        inputC_3: "",
        inputC_4: "",
        inputC_5: "",
        inputC_6: "",
        inputC_7: "",
        inputC_8: "",
        inputC_9: "",
        inputC_10: "",
        inputC_11: "",
        inputC_12: "",
        inputC_13: "",
        inputC_14: "",
        inputC_15: "",
        inputC_16: "",
        inputC_17: "",
        inputC_18: {}, // file

        sign1: {
          name: "",
          sign: "",
        },
        sign2: {
          name: "",
          sign: "",
        },
        fileList: [],
      },
    };
  },
};
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$w-inpu0: 260px;
$w-inpu1: 220px;
$w-inpu2: 140px;
.center-flex {
  display: flex;
  justify-content: center;
  align-items: center;
}

.bg-1 {
  background-color: #f9f9f9;
  border-bottom: $border;
}

.label-text {
  width: 110px;
  font-weight: 500;
  font-size: 14px;
  padding-right: 12px;
}

.mt-component-form {
  margin-top: 15px;
}

.text-box {
  line-height: 19px;
  margin-top: 15px;
  border: $border;
}

/* uploaded File */
.form-group {
  border: $border;
  overflow: auto;
  width: 100%;
  /*overflow-x: auto;*/

  &__header {
    height: 80px;
    width: 100%;
    display: flex;

    &-title {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &-title.title-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }
  }

  &__content {
    width: 100%;
    display: flex;

    &-row {
      min-width: $w-inpu2;
      border-left: $border;
      border-bottom: $border;
      padding: 7px;
    }

    &-row.row-checked {
      margin: 0;
      min-width: 40px;
      max-width: 40px;
      border-left: none;
      padding-left: 10px;
    }

    &-row.row-w2 {
      min-width: $w-inpu1;
    }
  }
}

.row-w1 {
  min-width: $w-inpu1;
}

.row-w0 {
  min-width: $w-inpu0;
}

.bx {
  border-left: $border;
  border-right: $border;
}

.br {
  border-right: $border;
}

.bb {
  border-bottom: $border;
}
</style>
